import * as moment from "moment";
import { createRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDeviceByBlock,
  // getDeviceListOptions,
  getDeviceOnlineOfflineInfo,
} from "../../../../../store/slices/dms-dashboard.slice";
import "../dms.scss";

import { useQuery } from "@tanstack/react-query";
import { getBlocksBySiteCode } from "src/store/slices/location-block.slice";
import { getSiteByTCCode } from "src/store/slices/location-site.slice";
import { getTownCouncils } from "src/store/slices/town-council.slice";
import * as yup from "yup";
import {
  getDeviceInfo,
  messageExchangeList,
} from "../../../../../core/api/services/dms.dashboard.service";
import TableComponent from "../../../../../core/components/table/table.component";
import InfoTileContainer from "../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../shared-elements/info-tile/info-tile.component";
import FilterFormComponent, {
  FilterFormConfig,
} from "../../../../../shared/filter-form/filter-form.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import Title from "../../../../../shared/title/title.component";
import { getCertificateStatus } from "../../../../../store/slices/certificate.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
import HasPermission from "src/core/guards/has-permission";
import "../../../admin.scss";

const DMSDashboardComponent = () => {
  const formRef = createRef();
  const messageExchangeFormRef = createRef();
  const deviceInfoFormRef = createRef();

  // const [tcOptions, setTCOptions] = useState<any>([]);
  // const [siteOptions, setSiteOptions] = useState<any>([]);
  // const [blockOptions, setBlockOptions] = useState<any>([]);
  const currentDateTime = moment().format("YYYY-MM-DD");
  const minDate = moment().subtract(7, "days").format("YYYY-MM-DD");

  const [currentState, setCurrentState] = useState("");

  const [tcOptionsMessageExchange, setTCOptionsMessageExchange] = useState<any>(
    [],
  );
  const [siteOptionsMessageExchange, setSiteOptionsMessageExchange] =
    useState<any>([]);
  const [blockOptionsMessageExchange, setBlockOptionsMessageExchange] =
    useState<any>([]);

  const [tcOptionsDeviceInfo, setTCOptionsDeviceInfo] = useState<any>([]);
  const [siteOptionsDeviceInfo, setSiteOptionsDeviceInfo] = useState<any>([]);
  const [blockOptionsDeviceInfo, setBlockOptionsDeviceInfo] = useState<any>([]);

  // const [assetOptions, setAssetOptions] = useState<any>([]);
  const [messageExchangeAssetOptions, setMessageExchangeAssetOptions] =
    useState<any>([]);

  // const [deviceInfoAssetOptions, setDeviceInfoAssetOptions] = useState<any>([]);

  // const [isAssetSearch, setIsAssetSearch] = useState<boolean>(true);
  const [isMessageExchangeSearch, setIsMessageExchangeSearch] =
    useState<boolean>(true);

  // const [isDeviceInfoSearch, setIsDeviceInfoSearch] = useState<boolean>(true);

  // const [selectedTC, setSelectedTC] = useState<any>(null);
  // const [selectedSite, setSelectedSite] = useState<any>(null);
  // const [selectedBlock, setSelectedBlock] = useState<any>(null);
  const [selectedTC] = useState<any>(null);
  const [selectedSite] = useState<any>(null);
  const [selectedBlock] = useState<any>(null);

  const [selectedTCMessageExchange, setSelectedTCMessageExchange] =
    useState<any>(null);
  const [selectedSiteMessageExchange, setSelectedSiteMessageExchange] =
    useState<any>(null);
  // const [selectedBlockMessageExchange, setSelectedBlockMessageExchange] =
  //   useState<any>(null);

  // const [selectedTCDeviceInfo, setSelectedTCDeviceInfo] = useState<any>(null);
  // const [selectedSiteDeviceInfo, setSelectedSiteDeviceInfo] =
  //   useState<any>(null);
  // const [selectedBlockDeviceInfo, setSelectedBlockDeviceInfo] =
  //   useState<any>(null);

  const [messageExchangeSelectedBlock, setMessageExchangeSelectedBlock] =
    useState<any>(null);
  const [deviceInfoSelectedBlock, setDeviceInfoSelectedBlock] =
    useState<any>(null);

  const [deviceStatusPage, setDeviceStatusPage] = useState<number>(1);
  const [messageExchangePage, setMessageExchangePage] = useState<number>(1);
  // const [alertPage, setAlertPage] = useState<number>(1);
  const pageSize = 10;

  const [deviceInfo_Data, setDeviceInfo_Data] = useState([] as any);
  // const [deviceListOptions, setDeviceListOptions] = useState([] as any);
  // const [deviceMessages_Data, setdeviceMessagesData] = useState([] as any);
  const [certificateStatus_Data, setCertificateStatus_Data] = useState(
    [] as any,
  );

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const townCouncilData = useSelector((state: any) => {
    return state.townCouncil.townCouncils;
  });

  const siteDataByTCCode = useSelector((state: any) => {
    return state.locationSite.sitesByTCCode;
  });

  const blockDataSiteCode = useSelector((state: any) => {
    return state.locationBlock.blocksBySiteCode;
  });

  const isLoadingTownCouncils = useSelector((state: any) => {
    return state.townCouncil.isLoadingTownCouncils;
  });

  const isLocationSitesByTCCode = useSelector((state: any) => {
    return state.locationSite.isLocationSitesByTCCode;
  });

  const isLoadingBlocksBySiteCode = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlocksBySiteCode;
  });

  const assetsData = useSelector((state: any) => {
    return state.dmsDashboard.deviceByBlock;
  });

  const [dsSearchValue, setDsSearchValue] = useState("");
  const [dlSearchValue] = useState("");
  // const [alSearchValue, setAlSearchValue] = useState("");

  const [filters] = useState<any>({});

  const [messageExchangeFilters, setMessageExchangeFilters] = useState<any>({
    startDate: formattedToday,
  });
  const [deviceInfoFilters, setDeviceInfoFilters] = useState<any>({});

  const [dsSortBy, setDsSortBy] = useState<any>(capitalizeFirst("deviceCode"));
  const [dsSortDirection, setDsSortDirection] = useState<any>("desc");

  // const onReset = () => {
  //   let form: any = formRef.current;

  //   form.resetForm();

  //   setFilterUpdateCount(filterUpdateCount + 1);

  //   setFormFilterInitialValues({
  //     townCouncil: "",
  //     site: "",
  //     block: "",
  //     deviceCode: 0,
  //     StartDate: "",
  //     EndDate: "",
  //   });

  //   setAlertPage(1);
  //   setFilters({});

  //   setAssetOptions([]);
  //   setSiteOptions([]);
  //   setBlockOptions([]);

  //   setIsAssetSearch(true);

  //   setSelectedTC(null);
  //   setSelectedSite(null);
  //   setSelectedBlock(null);
  //   setBlockChangeDetected(0);
  // };

  useEffect(() => {
    setDeviceStatusPage(1);
  }, [deviceInfoFilters]);

  useEffect(() => {
    setMessageExchangePage(1);
  }, [messageExchangeFilters]);

  useEffect(() => {
    // setAlertPage(1);
  }, [filters]);

  const onMessageExchangeReset = () => {
    let form: any = messageExchangeFormRef.current;

    form.resetForm();

    setMessageExchangeFilterUpdateCount(messageExchangeFilterUpdateCount + 1);

    setMessageExchangeFormFilterInitialValues({
      townCouncil: "",
      site: "",
      block: "",
      deviceCode: 0,
      startDate: formattedToday,
    });

    setMessageExchangePage(1);
    setMessageExchangeFilters({
      startDate: formattedToday,
    });

    setMessageExchangeAssetOptions([]);
    setSiteOptionsMessageExchange([]);
    setBlockOptionsMessageExchange([]);

    setIsMessageExchangeSearch(true);

    setSelectedTCMessageExchange(null);
    setSelectedSiteMessageExchange(null);
    // setSelectedBlockMessageExchange(null);
    setBlockChangeDetectedMessageExchange(0);
  };

  const onDeviceInfoReset = () => {
    let form: any = deviceInfoFormRef.current;
    form.resetForm();

    setDeviceInfoFilterUpdateCount(deviceInfoFilterUpdateCount + 1);

    setDeviceInfoFormFilterInitialValues({
      townCouncil: "",
      site: "",
      block: "",
      deviceCode: 0,
    });
    setDeviceInfoFilters({});
    setDeviceStatusPage(1);

    // setDeviceInfoAssetOptions([]);
    setSiteOptionsDeviceInfo([]);
    setBlockOptionsDeviceInfo([]);

    // setIsDeviceInfoSearch(true);

    // setSelectedTCDeviceInfo(null);
    // setSelectedSiteDeviceInfo(null);
    // setSelectedBlockDeviceInfo(null);
    setBlockChangeDetectedDeviceInfo(0);
  };

  const [dsColumns, setDsColumns] = useState([
    {
      title: "Device ID",
      label: "deviceCode",
      isSorted: true,
      type: "link",
      link: "/admin/dms/device",
      linkableField: "deviceId",
      // width: "18rem",
    },
    {
      title: "Device Display Name",
      label: "deviceDisplayName",
      type: "text",
      // width: "16rem",
    },
    {
      title: "Address",
      label: "address",
      type: "text",
      // width: "18rem",
    },
    {
      title: "Status",
      label: "deviceOnlineStatus",
      // width: "13rem",
    },
    {
      title: "Registration Time",
      label: "registrationTime",
      type: "datetime",
      // width: "18rem",
    },
    /* {
      title: "First Seen",
      label: "firstSeen",
      type: "datetime",
      width: "13rem",
    }, */
    {
      title: "Last Seen",
      label: "lastSeen",
      type: "datetime",
      // width: "13rem",
    },

    /*     {
      title: "Device Online Status",
      label: "deviceOnlineStatus",
      type: "text",
      width: "13rem",
    }, */
    {
      title: "Firmware Version",
      label: "firmwareVersion",
      type: "text",
      // width: "13rem",
    },
  ]);

  const [dlSortBy, setDlSortBy] = useState<any>(capitalizeFirst("deviceCode"));
  const [dlSortDirection, setDlSortDirection] = useState<any>("desc");

  const [dlColumns, setDlColumns] = useState([
    {
      title: "Device ID",
      label: "deviceCode",
      isSorted: true,
      type: "link",
      link: "/admin/dms/device",
      linkableField: "deviceId",
      width: "14rem",
    },
    {
      title: "Device Display Name",
      label: "deviceDisplayName",
      type: "text",
      width: "16rem",
    },
    {
      title: "Message Type",
      label: "alertType",
      type: "text",
      width: "10rem",
    },
    {
      title: "Timestamp",
      label: "timeStamp",
      type: "datetime",
      width: "12rem",
    },
    {
      title: "Details",
      label: "details",
      type: "text",
      width: "45rem",
    },
  ]);

  // const [alSortBy, setAlSortBy] = useState<any>(capitalizeFirst("deviceCode"));
  // const [alSortDirection, setAlSortDirection] = useState<any>("desc");

  // const [alColumns, setAlColumns] = useState([
  //   {
  //     title: "Device ID",
  //     label: "deviceCode",
  //     isSorted: true,
  //     type: "link",
  //     link: "/admin/dms/device",
  //     linkableField: "deviceId",
  //   },
  //   {
  //     title: "Device Display Name",
  //     label: "deviceDisplayName",
  //     type: "text",
  //     width: "16rem",
  //   },
  //   {
  //     title: "Alert Type",
  //     label: "payload",
  //   },
  //   {
  //     title: "Timestamp",
  //     label: "slot_data",
  //     type: "datetime",
  //   },
  //   {
  //     title: "Details",
  //     label: "details",
  //   },
  // ]);

  const [formFilterInitialValues, setFormFilterInitialValues] = useState({
    townCouncil: filters?.townCouncil || "",
    site: filters?.site || "",
    block: filters?.block || "",
    deviceCode: filters?.deviceCode || 0,
    StartDate: filters?.StartDate || "",
    EndDate: filters?.EndDate || "",
  });

  const [
    messageExchangeFormFilterInitialValues,
    setMessageExchangeFormFilterInitialValues,
  ] = useState({
    townCouncil: messageExchangeFilters?.townCouncil || "",
    site: messageExchangeFilters?.site || "",
    block: messageExchangeFilters?.block || "",
    deviceCode: messageExchangeFilters?.deviceCode || 0,
    startDate: messageExchangeFilters?.startDate || formattedToday,
  });

  const [
    deviceInfoFormFilterInitialValues,
    setDeviceInfoFormFilterInitialValues,
  ] = useState({
    townCouncil: deviceInfoFilters?.townCouncil || "",
    site: deviceInfoFilters?.site || "",
    block: deviceInfoFilters?.block || "",
    deviceCode: deviceInfoFilters?.deviceCode || 0,
  });

  // const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  const [
    messageExchangeFilterUpdateCount,
    setMessageExchangeFilterUpdateCount,
  ] = useState(0);

  const [deviceInfoFilterUpdateCount, setDeviceInfoFilterUpdateCount] =
    useState(0);

  // const [blockChangeDetected, setBlockChangeDetected] = useState(0);
  const [blockChangeDetected] = useState(0);
  const [
    blockChangeDetectedMessageExchange,
    setBlockChangeDetectedMessageExchange,
  ] = useState(0);
  const [blockChangeDetectedDeviceInfo, setBlockChangeDetectedDeviceInfo] =
    useState(0);

  // const reset: any = {
  //   label: "Reset",
  //   event: onReset,
  //   variant: "secondary",
  // };

  const messageExchangeReset: any = {
    label: "Reset",
    event: onMessageExchangeReset,
    variant: "secondary",
  };

  const deviceInfoReset: any = {
    label: "Reset",
    event: onDeviceInfoReset,
    variant: "secondary",
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
    dispatch(getDeviceOnlineOfflineInfo());
    dispatch(getCertificateStatus());
  }, [dispatch]);

  const { data: deviceStatus, isLoading: isLoadingDeviceStatus } = useQuery({
    queryKey: [
      "getDeviceInfo",
      deviceInfoFilters?.townCouncil,
      deviceInfoFilters?.site,
      deviceInfoFilters?.block,
      deviceInfoFilters?.deviceCode,
      deviceStatusPage,
      dsSortBy,
      dsSortDirection,
      dsSearchValue,
    ],
    queryFn: ({ signal }) =>
      getDeviceInfo(
        deviceInfoFilters?.townCouncil,
        deviceInfoFilters?.site,
        deviceInfoFilters?.block,
        deviceInfoFilters?.deviceCode,
        deviceStatusPage,
        pageSize,
        dsSortBy,
        dsSortDirection,
        dsSearchValue,
        signal,
      ),
  });

  const {
    data: messageExchangeDataList,
    isLoading: isLoadingMessageExchangeDataList,
  } = useQuery({
    queryKey: [
      "messageExchangeList",
      messageExchangeFilters?.townCouncil,
      messageExchangeFilters?.site,
      messageExchangeFilters?.block,
      messageExchangeFilters?.startDate,
      messageExchangeFilters?.deviceCode,
      messageExchangePage,
      pageSize,
      dlSortBy,
      dlSortDirection,
      dlSearchValue,
    ],
    queryFn: ({ signal }) =>
      messageExchangeList(
        messageExchangeFilters?.townCouncil,
        messageExchangeFilters?.site,
        messageExchangeFilters?.block,
        messageExchangeFilters?.startDate,
        messageExchangeFilters?.deviceCode,
        messageExchangePage,
        pageSize,
        dlSortBy,
        dlSortDirection,
        dlSearchValue,
        signal,
      ),
  });

  /* const {
    data: deviceAlertLists,
    isLoading: isLoadingDeviceAlerts,
    refetch,
  } = useQuery({
    queryKey: [
      "getDeviceAlertList",
      alertPage,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.deviceCode,
      alSortBy,
      alSortDirection,
      filters?.StartDate,
      filters?.EndDate,
      alSearchValue,
    ],
    queryFn: ({ signal }) =>
      getDeviceAlertList(
        alertPage,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.deviceCode,
        alSortBy,
        alSortDirection,
        filters?.StartDate,
        filters?.EndDate,
        alSearchValue,
        signal
      ),

    enabled: !!alertPage,
  }); */

  /*   const onRefetchData = () => {
    // setAlertPage(1);
    refetch();
  }; */

  const deviceOnlineOfflineInfo = useSelector((state: any) => {
    return state.dmsDashboard.deviceOnlineOfflineInfo;
  });

  const isLoadingDeviceOnlineOfflineInfo = useSelector((state: any) => {
    return state.dmsDashboard.isLoadingDeviceOnlineOfflineInfo;
  });

  const certificateStatusData = useSelector((state: any) => {
    return state.certificate.certificateStatus;
  });

  const isLoadingCertificateStatus = useSelector((state: any) => {
    return state.certificate.isLoadingCertificateStatus;
  });

  // const deviceListOptionData = useSelector((state: any) => {
  //   return state.dmsDashboard.deviceListOptions;
  // });

  const handleDeviceStatusChangePage = useCallback((page: number): void => {
    setDeviceStatusPage(page);
  }, []);

  const handleMessageExchangeChangePage = useCallback((page: number): void => {
    setMessageExchangePage(page);
  }, []);

  // const handleAlertChangePage = useCallback((page: number): void => {
  //   setAlertPage(page);
  // }, []);

  // const onTypeAheadInputChange = (value: string) => {
  //   if (value.length) {
  //     let searchText = value;
  //     dispatch(getDeviceListOptions({ searchText }));
  //   }
  // };

  // const onChangeTC = (selectedTC: any) => {
  //   setSiteOptions([]);
  //   setBlockOptions([]);
  //   setSelectedTC(selectedTC);
  //   setCurrentState("alert");
  //   setBlockChangeDetected(blockChangeDetected + 1);
  //   setIsAssetSearch(true);

  //   const form: any = formRef.current;

  //   if (form) {
  //     // Get all field names except 'towncouncil'
  //     const fieldNames = Object.keys(form.values).filter(
  //       (name) => name !== "towncouncil",
  //     );

  //     // Reset each field to empty, except 'towncouncil'
  //     fieldNames.forEach((fieldName) => {
  //       if (fieldName === "site" || fieldName === "block") {
  //         form.setFieldValue(fieldName, "", false); // false to avoid validation after setting field
  //       }
  //     });

  //     // console.log(form.values); // This will now reflect the reset operation
  //   }

  //   setFormFilterInitialValues({
  //     ...formFilterInitialValues,
  //     townCouncil: selectedTC,
  //     site: "",
  //     block: "",
  //   });

  //   if (!selectedTC) return;

  //   dispatch(getSiteByTCCode({ tcCode: selectedTC }));
  //   // onChangeLocation();
  // };

  const onChangeTCMessageExchange = (selectedTC: any) => {
    setSiteOptionsMessageExchange([]);
    setBlockOptionsMessageExchange([]);
    setBlockChangeDetectedMessageExchange(
      blockChangeDetectedMessageExchange + 1,
    );
    setCurrentState("message");
    setSelectedTCMessageExchange(selectedTC);
    setIsMessageExchangeSearch(true);

    const form: any = messageExchangeFormRef.current;

    if (form) {
      // Get all field names except 'towncouncil'
      const fieldNames = Object.keys(form.values).filter(
        (name) => name !== "towncouncil",
      );

      // Reset each field to empty, except 'towncouncil'
      fieldNames.forEach((fieldName) => {
        if (fieldName === "site" || fieldName === "block") {
          form.setFieldValue(fieldName, "", false); // false to avoid validation after setting field
        }
      });

      // console.log(form.values); // This will now reflect the reset operation
    }

    setMessageExchangeFormFilterInitialValues({
      ...messageExchangeFormFilterInitialValues,
      townCouncil: selectedTC,
      site: "",
      block: "",
    });

    if (!selectedTC) return;

    dispatch(getSiteByTCCode({ tcCode: selectedTC }));
  };

  const onChangeTCDeviceInfo = (selectedTC: any) => {
    setSiteOptionsDeviceInfo([]);
    setBlockOptionsDeviceInfo([]);

    // setSelectedTCDeviceInfo(selectedTC);

    setBlockChangeDetectedDeviceInfo(blockChangeDetectedDeviceInfo + 1);
    setCurrentState("device");
    // setIsDeviceInfoSearch(true);

    const form: any = deviceInfoFormRef.current;

    if (form) {
      // Get all field names except 'towncouncil'
      const fieldNames = Object.keys(form.values).filter(
        (name) => name !== "towncouncil",
      );

      // Reset each field to empty, except 'towncouncil'
      fieldNames.forEach((fieldName) => {
        if (fieldName === "site" || fieldName === "block") {
          form.setFieldValue(fieldName, "", false); // false to avoid validation after setting field
        }
      });

      // console.log(form.values); // This will now reflect the reset operation
    }

    setDeviceInfoFormFilterInitialValues({
      ...deviceInfoFormFilterInitialValues,
      townCouncil: selectedTC,
      site: "",
      block: "",
    });

    if (!selectedTC) return;

    dispatch(getSiteByTCCode({ tcCode: selectedTC }));
    // onChangeLocation();
  };

  // const onChangeSite = (selectedSite: any) => {
  //   setBlockOptions([]);

  //   setFormFilterInitialValues({
  //     ...formFilterInitialValues,
  //     site: selectedSite,
  //     block: "",
  //   });

  //   setSelectedSite(selectedSite);
  //   setCurrentState("alert");
  //   setBlockChangeDetected(blockChangeDetected + 1);
  //   setIsAssetSearch(true);

  //   if (!selectedSite) return;

  //   dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
  // };

  const onChangeSiteMessageExchange = (selectedSite: any) => {
    setBlockOptionsMessageExchange([]);

    setMessageExchangeFormFilterInitialValues({
      ...messageExchangeFormFilterInitialValues,
      site: selectedSite,
      block: "",
    });

    setSelectedSiteMessageExchange(selectedSite);
    setBlockChangeDetectedMessageExchange(
      blockChangeDetectedMessageExchange + 1,
    );
    setCurrentState("message");

    setIsMessageExchangeSearch(true);
    if (!selectedSite) return;
    dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
  };

  const onChangeSiteDeviceInfo = (selectedSite: any) => {
    setBlockOptionsDeviceInfo([]);

    setDeviceInfoFormFilterInitialValues({
      ...deviceInfoFormFilterInitialValues,
      site: selectedSite,
      block: "",
    });

    // setSelectedSiteDeviceInfo(selectedSite);

    setBlockChangeDetectedDeviceInfo(blockChangeDetectedDeviceInfo + 1);
    setCurrentState("device");
    // setIsDeviceInfoSearch(true);

    if (!selectedSite) return;
    dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
  };

  // const onChangeBlock = (selectedBlock: any) => {
  //   setAssetOptions([]);

  //   setFormFilterInitialValues({
  //     ...formFilterInitialValues,
  //     block: selectedBlock,
  //   });

  //   setIsAssetSearch(false);
  //   // setFilterUpdateCount(filterUpdateCount + 1);
  //   setBlockChangeDetected(blockChangeDetected + 1);

  //   setSelectedBlock(selectedBlock);
  //   setCurrentState("alert");

  //   if (!selectedBlock) return;
  // };

  const onChangeMessageExchangeBlock = (selectedBlock: any) => {
    setMessageExchangeAssetOptions([]);

    setMessageExchangeFormFilterInitialValues({
      ...messageExchangeFormFilterInitialValues,
      block: selectedBlock,
    });

    setIsMessageExchangeSearch(false);
    setBlockChangeDetectedMessageExchange(
      blockChangeDetectedMessageExchange + 1,
    );
    setMessageExchangeSelectedBlock(selectedBlock);
    setCurrentState("message");
    if (!selectedBlock) return;
  };

  const onChangeDeviceInfoBlock = (selectedBlock: any) => {
    // setDeviceInfoAssetOptions([]);
    setDeviceInfoFormFilterInitialValues({
      ...deviceInfoFormFilterInitialValues,
      block: selectedBlock,
    });

    // setIsDeviceInfoSearch(false);
    setBlockChangeDetectedDeviceInfo(blockChangeDetectedDeviceInfo + 1);
    setDeviceInfoSelectedBlock(selectedBlock);
    setCurrentState("device");
    if (!selectedBlock) return;
  };

  const messageExchangeFilterFormConfig: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "townCouncil",
            placeholder: "Select Town Council *",
            type: "searchable-select",
            options: tcOptionsMessageExchange,
            onChange: onChangeTCMessageExchange,
            required: true,
            isLoading: isLoadingTownCouncils,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "site",
            placeholder: "Select Site *",
            type: "searchable-select",
            options: siteOptionsMessageExchange,
            onChange: onChangeSiteMessageExchange,
            required: true,
            isLoading: isLocationSitesByTCCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "block",
            placeholder: "Select Block *",
            type: "searchable-select",
            options: blockOptionsMessageExchange,
            onChange: onChangeMessageExchangeBlock,
            required: true,
            isLoading: isLoadingBlocksBySiteCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "deviceCode",
            placeholder: "Select Device",
            type: "searchable-select",
            required: false,
            selectType: "single",
            options: messageExchangeAssetOptions,
            isLoading: true,
            disabled: isMessageExchangeSearch,
            resetSearchableSelect: blockChangeDetectedMessageExchange,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "startDate",
            placeholder: "Select Date",
            type: "date",
            required: true,
            isLoading: false,
            maxDate: currentDateTime,
            minDate: minDate,
          },
        ],
      },
    ],
  };

  const deviceInfoFilterFormConfig: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "townCouncil",
            placeholder: "Select Town Council *",
            type: "searchable-select",
            options: tcOptionsDeviceInfo,
            onChange: onChangeTCDeviceInfo,
            required: true,
            isLoading: isLoadingTownCouncils,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "site",
            placeholder: "Select Site *",
            type: "searchable-select",
            options: siteOptionsDeviceInfo,
            onChange: onChangeSiteDeviceInfo,
            required: true,
            isLoading: isLocationSitesByTCCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "block",
            placeholder: "Select Block *",
            type: "searchable-select",
            options: blockOptionsDeviceInfo,
            onChange: onChangeDeviceInfoBlock,
            required: true,
            isLoading: isLoadingBlocksBySiteCode,
          },
        ],
      },
      /*       {
        controlGroup: [
          {
            name: "deviceCode",
            placeholder: "Select Device",
            type: "searchable-select",
            required: false,
            selectType: "single",
            options: deviceInfoAssetOptions,
            isLoading: true,
            disabled: isDeviceInfoSearch,
            resetSearchableSelect: blockChangeDetectedDeviceInfo,
          },
        ],
      }, */
    ],
  };

  // const onSubmitFilter = () => {
  //   let form: any = formRef.current;

  //   if (form) {
  //     form.handleSubmit();

  //     const { townCouncil, site, block } =
  //       form.values;

  //     if (!townCouncil || !site || !block) {
  //       return;
  //     }

  //     setFilters(form.values);

  //     // onRefetchData();
  //   }
  // };

  const onSubmitMessageExchangeFilter = () => {
    let form: any = messageExchangeFormRef.current;

    if (form) {
      form.handleSubmit();

      const { townCouncil, site, block, startDate } = form.values;

      if (!townCouncil || !site || !block || !startDate) {
        return;
      }

      setMessageExchangeFilters(form.values);

      // onRefetchData();
    }
  };

  const onSubmitDeviceInfoFilter = () => {
    let form: any = deviceInfoFormRef.current;

    if (form) {
      form.handleSubmit();

      const { townCouncil, site, block } = form.values;

      if (!townCouncil || !site || !block) {
        return;
      }

      setDeviceInfoFilters(form.values);
      // onRefetchData();
    }
  };

  // const filterActionConfig: any = {
  //   label: "Filter",
  //   event: onSubmitFilter,
  //   variant: "primary",
  // };

  const messageExchangeFilterActionConfig: any = {
    label: "Filter",
    event: onSubmitMessageExchangeFilter,
    variant: "primary",
  };

  const deviceInfoFilterActionConfig: any = {
    label: "Filter",
    event: onSubmitDeviceInfoFilter,
    variant: "primary",
  };

  // const emptyAlertConfig = {
  //   title: "No Alert Found",
  //   description: "",
  // };
  const emptyMessageExchangeConfig = {
    title: "No Messages Found",
    description: "",
  };
  const emptyDeviceInfoConfig = {
    title: "No Devices Found",
    description: "",
  };

  const dsHandleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setDsSortBy(sortBy);
      setDsSortDirection(sortDirection);

      const copyColumns: any = await TableSort(dsColumns, sortBy);
      setDsColumns(copyColumns);
    },
    [],
  );

  const dlHandleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setDlSortBy(sortBy);
      setDlSortDirection(sortDirection);

      const copyColumns: any = await TableSort(dlColumns, sortBy);
      setDlColumns(copyColumns);
    },
    [],
  );

  // const alHandleChangeSort = useCallback(
  //   async (sortBy: string, sortDirection: any) => {
  //     if (!sortBy || !sortDirection) return;

  //     setAlSortBy(sortBy);
  //     setAlSortDirection(sortDirection);

  //     const copyColumns: any = await TableSort(alColumns, sortBy);
  //     setAlColumns(copyColumns);
  //   },
  //   [],
  // );

  const dsHandleSearch = useCallback((searchVal: string): void => {
    setDsSearchValue(searchVal);
  }, []);

  // const dlHandleSearch = useCallback((searchVal: string): void => {
  //   setDlSearchValue(searchVal);
  // }, []);

  // const alHandleSearch = useCallback((searchVal: string): void => {
  //   setAlSearchValue(searchVal);
  // }, []);

  //
  useEffect(() => {
    // Somehow startDate and endDate is not showing in formref that's why this method
    // Alert
    const form: any = formRef.current;
    const startDate = form?.values?.StartDate;
    const endDate = form?.values?.EndDate;

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      StartDate: startDate,
      EndDate: endDate,
    });
  }, [blockChangeDetected]);

  useEffect(() => {
    // Message Exchange
    const form: any = messageExchangeFormRef.current;
    const startDate = form.values.startDate;

    setMessageExchangeFormFilterInitialValues({
      ...messageExchangeFormFilterInitialValues,
      startDate: startDate,
    });
  }, [blockChangeDetectedMessageExchange]);

  useEffect(() => {
    if (selectedTC && selectedSite && selectedBlock) {
      dispatch(
        getDeviceByBlock({
          blockCode: selectedBlock,
        }),
      );
    }
  }, [selectedBlock]);

  useEffect(() => {
    if (
      selectedTCMessageExchange &&
      selectedSiteMessageExchange &&
      messageExchangeSelectedBlock
    ) {
      dispatch(
        getDeviceByBlock({
          blockCode: messageExchangeSelectedBlock,
        }),
      );
    }
  }, [messageExchangeSelectedBlock]);

  /*   useEffect(() => {
    if (
      selectedTCDeviceInfo &&
      selectedSiteDeviceInfo &&
      deviceInfoSelectedBlock
    ) {
      dispatch(
        getDeviceByBlock({
          blockCode: deviceInfoSelectedBlock,
        })
      );
    }
  }, [deviceInfoSelectedBlock]); */

  useEffect(() => {
    const deviceIDs: string[] = assetsData?.map(
      (options: { id: string; sensorDisplayName: string }) => {
        return {
          label: options?.sensorDisplayName,
          value: options?.id,
        };
      },
    );

    if (assetsData.length > 0) {
      if (messageExchangeSelectedBlock) {
        setMessageExchangeAssetOptions(deviceIDs);
        setIsMessageExchangeSearch(false);
      }
      if (selectedBlock) {
        // setAssetOptions(deviceIDs);
        // setIsAssetSearch(false);
      }
      if (deviceInfoSelectedBlock) {
        // setIsDeviceInfoSearch(false);
        // setDeviceInfoAssetOptions(deviceIDs);
      }
    }
  }, [assetsData]);
  const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

  useEffect(() => {
    const tcs = townCouncilData?.data?.map((tc: any) => ({
      label: tc?.name,
      value: tc?.tcCode,
    }));

    if (!tcs) return;
    const optionsWithEmptyString = [
      { label: "Select Town Council *", value: "" },
      ...tcs,
    ];
    // if user is TC Admin only 1 tc is available
    if (tcs?.length === 1) {
      setCurrentTC(tcs[0]);
    }

    // setTCOptions(optionsWithEmptyString);

    setTCOptionsMessageExchange(optionsWithEmptyString);
    setTCOptionsDeviceInfo(optionsWithEmptyString);

    setMessageExchangeFilterUpdateCount(messageExchangeFilterUpdateCount + 1);
    setDeviceInfoFilterUpdateCount(deviceInfoFilterUpdateCount + 1);
  }, [townCouncilData]);

  useEffect(() => {
    if (currentTC?.value?.length) {
      setMessageExchangeFormFilterInitialValues((prev) => ({
        ...prev,
        townCouncil: currentTC?.value,
      }));

      setDeviceInfoFormFilterInitialValues((prev) => ({
        ...prev,
        townCouncil: currentTC?.value,
      }));

      dispatch(getSiteByTCCode({ tcCode: currentTC.value }));
    }
  }, [currentTC]);

  useEffect(() => {
    const sites = siteDataByTCCode?.data?.map((site: any) => ({
      label: site?.name,
      value: site?.siteCode,
    }));

    if (!sites?.length) return;

    const optionsWithEmptyString = [
      { label: "Select Site *", value: "" },
      ...sites,
    ];

    if (currentState === "alert") {
      // setSiteOptions(optionsWithEmptyString);
    } else if (currentState === "message") {
      setSiteOptionsMessageExchange(optionsWithEmptyString);
    } else {
      setSiteOptionsDeviceInfo(optionsWithEmptyString);
    }
  }, [siteDataByTCCode]);

  useEffect(() => {
    const blocks = blockDataSiteCode?.data?.map((block: any) => ({
      label: block?.blockName,
      value: block?.blockCode,
    }));
    if (!blocks) return;

    const optionsWithEmptyString = [
      { label: "Select Block *", value: "" },
      ...blocks,
    ];

    if (currentState === "alert") {
      // setBlockOptions(optionsWithEmptyString);
    } else if (currentState === "message") {
      setBlockOptionsMessageExchange(optionsWithEmptyString);
    } else {
      setBlockOptionsDeviceInfo(optionsWithEmptyString);
    }
  }, [blockDataSiteCode]);

  // useEffect(() => {
  //   const listOptions = deviceListOptionData?.data?.map((device: any) => ({
  //     label: device.deviceCode,
  //     value: device.deviceCode,
  //   }));

  //   // setDeviceListOptions(listOptions);
  // }, [deviceListOptionData]);

  useEffect(() => {
    setDeviceInfo_Data([
      {
        title: "Total Online",
        content: deviceOnlineOfflineInfo?.onlineDevice || 0,
      },
      {
        title: "Total Offline",
        content: deviceOnlineOfflineInfo?.offlineDevice || 0,
      },
    ]);
  }, [deviceOnlineOfflineInfo]);

  useEffect(() => {
    setCertificateStatus_Data([
      {
        title: "Valid",
        content: certificateStatusData?.valid || 0,
      },
      {
        title: "Expired",
        content: certificateStatusData?.expired || 0,
      },
      {
        title: "Restricted",
        content: certificateStatusData?.restricted || 0,
      },
      {
        title: "Revoked",
        content: certificateStatusData?.revoked || 0,
      },
      {
        title: "Expiring in 7 days",
        content: certificateStatusData?.expire7Days || 0,
      },
    ]);
  }, [certificateStatusData]);

  useEffect(() => {
    // setSiteOptions([]);
    // setBlockOptions([]);
    setSiteOptionsMessageExchange([]);
    setBlockOptionsMessageExchange([]);
    setSiteOptionsDeviceInfo([]);
    setBlockOptionsDeviceInfo([]);

    // setAssetOptions([]);
    setMessageExchangeAssetOptions([]);
    // setIsAssetSearch(true);
    setIsMessageExchangeSearch(true);
    // setIsDeviceInfoSearch(true);
    setCurrentState("");
  }, []);

  // const validationSchema = yup.object().shape({
  //   townCouncil: yup.string().required("Town Council is required"),
  //   site: yup.string().required("Site is required"),
  //   block: yup.string().required("Block is required"),
  // });

  const messageExchangeValidationSchema = yup.object().shape({
    townCouncil: yup.string().required("Town Council is required"),
    site: yup.string().required("Site is required"),
    block: yup.string().required("Block is required"),
    startDate: yup.date().required("Start Date is required"),
    deviceCode: yup.string().required("Device code is required"),
  });

  const deviceInfoValidationSchema = yup.object().shape({
    townCouncil: yup.string().required("Town Council is required"),
    site: yup.string().required("Site is required"),
    block: yup.string().required("Block is required"),
    // deviceCode: yup
    //   .string()
    //   .required(
    //     "Device code is required, Please select a valid device from the suggesstion list"
    //   ),
  });

  return (
    <div className="" style={{ zIndex: "9999" }}>
      <HasPermission
        moduleName="Device"
        actionName="View-Device"
        isRoute={false}
      >
        <Title title="Overview" />
        <div className="mt-3">
          <div className="flex">
            <div className="w-lg-50">
              <InfoTileContainer header="Certificate Status">
                {certificateStatus_Data.map((data: any) => (
                  <InfoTileComponent
                    key={data.title}
                    title={data.title}
                    value={data.content}
                    isLoading={isLoadingCertificateStatus}
                  />
                ))}
              </InfoTileContainer>
            </div>
            <div className="w-lg-50 ms-lg-4">
              {/* <div> */}
              <InfoTileContainer header="Device Info">
                {deviceInfo_Data.map((data: any) => (
                  <InfoTileComponent
                    key={data.title}
                    title={data.title}
                    value={data.content}
                    isLoading={isLoadingDeviceOnlineOfflineInfo}
                  />
                ))}
              </InfoTileContainer>
              {/* </div> */}
              {/* <div className="mt-3">
                <InfoTileContainer header="Device Messages (Today)">
                  {deviceMessages_Data.map((data: any) => (
                    <InfoTileComponent
                      title={data.title}
                      value={data.content}
                      isLoading={isLoadingDeviceMessageCount}
                    />
                  ))}
                </InfoTileContainer>
              </div> */}
            </div>
          </div>
        </div>
      </HasPermission>

      <div className="mt-4">
        <Title title="Device Info" />
      </div>

      {/* device status table */}
      <div>
        <h4 className="mt-4">Device Info</h4>
        <div className="d-flex gap-3 justify-content-end table-generic-action  table-toolbar">
          <SearchBarComponent
            placeholder="Search Device"
            methodToDispatch={deviceStatus}
            getSearch={dsHandleSearch}
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <FilterFormComponent
            key={deviceInfoFormFilterInitialValues?.townCouncil}
            formRef={deviceInfoFormRef}
            initialValues={deviceInfoFormFilterInitialValues}
            formConfig={deviceInfoFilterFormConfig}
            actionConfig={deviceInfoFilterActionConfig}
            resetButton={deviceInfoReset}
            validation={deviceInfoValidationSchema}
            filterUpdateCount={deviceInfoFilterUpdateCount}
          />
        </div>

        <div className="my-3">
          <TableComponent
            tableHeaders={dsColumns}
            emptyConfig={emptyDeviceInfoConfig}
            data={deviceStatus?.data}
            totalNumberOfRecords={deviceStatus?.numberOfRecords}
            pageSize={pageSize}
            current={deviceStatusPage}
            onChangePage={handleDeviceStatusChangePage}
            onChangeSort={dsHandleChangeSort}
            isLoadingData={isLoadingDeviceStatus}
          />
        </div>
      </div>

      {/* Message Exchange table */}
      <div>
        <h4 className="mt-4">Message Exchange</h4>

        {/* <div className="d-flex gap-3 justify-content-end table-generic-action">
          <SearchBarComponent
            placeholder="Search Device"
            methodToDispatch={messageExchangeDataList}
            getSearch={dlHandleSearch}
          />
        </div> */}

        <div style={{ marginTop: "1rem" }}>
          <FilterFormComponent
            key={messageExchangeFormFilterInitialValues?.townCouncil}
            formRef={messageExchangeFormRef}
            initialValues={messageExchangeFormFilterInitialValues}
            formConfig={messageExchangeFilterFormConfig}
            actionConfig={messageExchangeFilterActionConfig}
            resetButton={messageExchangeReset}
            validation={messageExchangeValidationSchema}
            filterUpdateCount={messageExchangeFilterUpdateCount}
          />
        </div>

        <div className="my-3">
          <TableComponent
            tableHeaders={dlColumns}
            emptyConfig={emptyMessageExchangeConfig}
            data={messageExchangeDataList?.data}
            totalNumberOfRecords={messageExchangeDataList?.numberOfRecords}
            pageSize={pageSize}
            current={messageExchangePage}
            onChangePage={handleMessageExchangeChangePage}
            onChangeSort={dlHandleChangeSort}
            isLoadingData={isLoadingMessageExchangeDataList}
          />
        </div>
      </div>

      {/* alert table */}

      {/* <div>
        <h4 className="mt-4">Alerts</h4>
        <div>
          <FilterFormComponent
            formRef={formRef}
            initialValues={formFilterInitialValues}
            formConfig={filterFormConfig}
            actionConfig={filterActionConfig}
            validation={validationSchema}
            resetButton={reset}
            filterUpdateCount={filterUpdateCount}
          />
        </div>
        <div>
          <div className="my-3">
            <TableComponent
              tableHeaders={alColumns}
              emptyConfig={emptyAlertConfig}
              data={deviceAlertLists?.data}
              totalNumberOfRecords={deviceAlertLists?.numberOfRecords}
              pageSize={pageSize}
              current={alertPage}
              onChangePage={handleAlertChangePage}
              onChangeSort={alHandleChangeSort}
              isLoadingData={isLoadingDeviceAlerts}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default DMSDashboardComponent;
